import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_PrettyPrint_Unary.scss';
import { _className } from '@nu-art/thunderstorm-frontend';
import { BadImplementationException, exists } from '@nu-art/ts-common';
import { PPDescription, PPIndicatorStatus } from '../../Component_PrettyPrint_Description/Component_PrettyPrint_Description.js';
const getTitle = (operator) => {
    switch (operator) {
        case 'not':
            return 'Not of the following:';
        case 'negative':
            return 'Negative of the following';
        case 'positive':
            return 'Positive of the following';
    }
};
const getStatus = (valueNode, interactive) => {
    if (!interactive)
        return;
    switch (typeof valueNode?.value) {
        case 'number':
            return PPIndicatorStatus.pass;
        case 'boolean':
            return valueNode.value ? PPIndicatorStatus.pass : PPIndicatorStatus.fail;
        default:
            return PPIndicatorStatus.dataNeeded;
    }
};
export const Component_PrettyPrint_Unary = (props) => {
    if (exists(props.valueNode) && props.valueNode.type !== 'unary')
        throw new BadImplementationException(`ValueTree_Node type mismatch: expected "unary", got "${props.valueNode.type}"`);
    const status = getStatus(props.valueNode, props.interactive);
    const title = getTitle(props.expression.operator);
    const className = _className('unary-description', status);
    if (!title)
        return _jsx(PPDescription, { className: className, children: _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsxs(PPDescription.Title, { children: ["Unhandled unary operator: ", props.expression.operator] })] }) });
    return _jsxs(PPDescription, { className: className, children: [_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: title })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.operand, props.valueNode?.inner)] })] });
};
//# sourceMappingURL=Component_PrettyPrint_Unary.js.map